export default '/static/frontend/ReachDigital/12gobiking/dist/assets/afterpay-wit-648579ed.svg'